"use client"
import {useCallback} from 'react';

interface ArrayItem {
    id: number;
    title: string;
    variation_id: number;
    is_active: number;
    show_order: number | null;
    creator_id: number;
    created_at: string;
    updated_at: string;
    media: any[];
    pivot?: {
        product_item_id: number;
        variation_option_id: number;
    };
}

export function useArrayFilter(){
    return useCallback((secondArray : ArrayItem[] ,  longArray : ArrayItem[]) => {
        try {
            const idsToMatch = new Set(secondArray.map(item => item.id));
            return longArray.filter(item => idsToMatch.has(item.id));
        } catch (error) {
            return []
        }
    }, [])
}
